import { Button, Col, Form, Input, Row, Select } from "antd";
import PropTypes from "prop-types";

function CurrentRent(props) {
  const { Option } = Select;

  const { next, prev, handleCancel } = props;

  const onFinish = (values) => {
    console.log('Success:', values);
    next();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="pt-3 stepper-basic-data">
      <h3 className="font-weight-bold mb-0 mt-1 pt-4 text-blue">
        Current Rent
      </h3>
      <Form
        name="basic"
        className="user-modal flex-column justify-content-between d-flex"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={24}>
          <Col xs={8}>
            <Form.Item label="Per Sq M	" name="perSqM" rules={[
              {
                required: true,
                message: 'Please input Per Sq M!',
              },
            ]}>
              <Input type="number" placeholder="Per Sq M" />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Per Month" name="perMonth"
              rules={[
                {
                  required: false,
                  message: 'Please input rent!',
                },
              ]}>
              <Input disabled placeholder="Per Month" />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item label="Per Year" name="perYear"
              rules={[
                {
                  required: false,
                  message: 'Please input per year!',
                },
              ]}>
              <Input disabled placeholder="Per Year" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={8}>
            <Form.Item label="VAT" >
            <Select placeholder="Select" allowClear>
                <Option value="1">Yes</Option>
                <Option value="2">No</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="stepper-action-btn">
          <Col xs={24}>
            <div className="steps-action d-flex justify-content-between align-items-center mt-3">
              <div>
                <Button
                  style={{
                    margin: "0 8px",
                  }}
                  className="btn-primary"
                  onClick={prev}
                >
                  Previous
                </Button>
                <Button
                  style={{
                    margin: "0 8px",
                  }}
                  className="btn-cancel"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button type="primary" className="btn-primary" htmlType="submit">
                  Next
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default CurrentRent;

CurrentRent.propTypes = {
  next: PropTypes.node.isRequired,
  handleCancel: PropTypes.node.isRequired,
  prev: PropTypes.node.isRequired,
};